/**
 * Single source of truth for sitewide head metadata.
 *
 * The same values are mirrored as static fallback tags in `index.html`
 * (for crawlers that do not execute JS). Those static tags carry
 * `data-rh="true"`, so react-helmet-async replaces them on mount
 * instead of leaving duplicates behind.
 *
 * If you change anything here, update the matching tags in index.html.
 */
export const SITE_URL = 'https://giztoo.com';
export const SITE_NAME = 'GizToo';
export const SITE_TITLE = 'GizToo — Tech Gadgets & Accessories | Free Shipping $35+';
export const SITE_DESCRIPTION =
  'Shop the latest tech gadgets, phone accessories, smart home devices, and more at GizToo. Free shipping on orders $35+. 30-day returns.';
export const SITE_OG_IMAGE = `${SITE_URL}/og-image.png`;
